<template>
  <div >
    <!-- ================== Selector de servicio ================== -->
    <div v-if="!disabled" class="service-switch">
      <button
        v-for="tipo in tipos_visible"
        :key="tipo.valor"
        type="button"
        class="service-btn"
        :class="[`service-${tipo.valor}`, { active: localValue.tipo === tipo.valor }]"
        @click="set_tipo(tipo.valor)"
      >
        {{ tipo.label }}
      </button>
    </div>

    <!-- ================== Formularios por servicio ================== -->
    <div class="service-forms">
      <transition-group name="slide-fade">
        <Mesa
          key="mesa-component"
          v-show="localValue.tipo == 'mesa'"
          v-model="localValue.mesapago"
          :mesas="mesas"
          :meseros="meseros"
          :disabled="disabled"
        />
        <Llevar
          key="llevar-component"
          v-show="localValue.tipo == 'llevar'"
          v-model="localValue.claveLlevar"
          :data="tiposVenta"
          :disabled="disabled"
        />
        <Domicilio
          :orden="orden"
          :repartidores="repartidores"
          :colonias="colonias"
          :disabled="disabled"
          :tipo="tipodomicilio"
          :impresoras="impresoras"
          :POSInfo="POSInfo"
          key="domicilio-component"
          v-model="localValue.domicilio"
          v-show="localValue.tipo == 'domicilio'"
          @saleRepa="saleRepa"
        />
        <Reserva
          v-if="config_11"
          key="reservacion-component"
          :disabled="disabled"
          v-show="localValue.tipo != ''"
          v-model="localValue.reservacion"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Mesa from "../components/MesaPagoComponent.vue";
import Llevar from "../components/LlevarPagoComponent.vue";
import Domicilio from "../components/DomicilioPagoComponent.vue";
import { DomicilioPago } from "../controllers/DataController";
import Reserva from "../components/ReservaComponent.vue";
import { Toast } from "../controllers/DataController";

export default {
  name: "TipoServicioSelector",
  props: {
    value: { required: true },
    disabled: { type: Boolean, default: false },
    orden: { type: Object, default: () => ({}) },
    mesas: { type: Array, default: () => [] },
    meseros: { type: Array, default: () => [] },
    repartidores: { type: Array, default: () => [] },
    tipodomicilio: { type: Object, default: () => ({}) },
    colonias: { type: Array, default: () => [] },
    tiposVenta: { type: Array, default: () => [] },
    impresoras: { type: Array, default: () => [] },
    POSInfo: { type: Object, default: () => ({}) },
  },
  components: { Reserva, Mesa, Llevar, Domicilio },
  data() {
    return {
      localValue: this.value,
      tipos: this.$config.servicios,
      config_11: false,
    };
  },
  computed: {
    tipos_visible() {
      return this.tipos.filter((x) => x.visible);
    },
  },
  methods: {
    set_tipo(x) {
      this.localValue.tipo = x;
    },
    saleRepa() {
      this.$emit("saleRepa", this.localValue.domicilio);
    },
  },
  watch: {
    ["localValue.tipo"](newValue) {
      if (newValue == null || newValue == "") {
        this.localValue.reservacion = {
          strApellidoReferencia: "",
          strHabitacion: "",
          intHotReservacion: 0,
        };
        this.localValue.domicilio = new DomicilioPago();
      }
    },
    ["orden.intPOSEnc"](newValue) {
      if (newValue > 0) {
        if (this.localValue.tipo == "domicilio") {
          this.localValue.domicilio.strTelefono = this.orden.cliente.strTelefono;
          this.localValue.domicilio.strDireccion = this.orden.cliente.strDireccion;
          this.localValue.domicilio.strTelefono2 = this.orden.cliente.strTelefono2;
          this.localValue.domicilio.intEmpleado = this.orden.intEmpleado;
          this.localValue.domicilio.strEntreCalle = this.orden.cliente.strEntreCalle;
          this.localValue.domicilio.strColonia = this.orden.cliente.strColonia;
          this.localValue.domicilio.strPoblacion = this.orden.cliente.strPoblacion;
          this.localValue.domicilio.strNombre = this.orden.cliente.strNombre;
          this.localValue.domicilio.strReferencia = this.orden.cliente.strReferencia;
          this.localValue.domicilio.strRFC = this.orden.cliente.strRFC;
        }
      }
    },
    reservacion(newValue) {
      this.$emit("change_reservacion", newValue);
    },
    mesa_value(newValue) {
      this.$emit("change_mesa", newValue);
    },
    llevar_value(newValue) {
      this.$emit("change_llevar", newValue);
    },
    domicilio_value(newValue) {
      this.$emit("change_domicilio", newValue);
    },
    localValue: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true,
    },
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      deep: true,
    },
  },
  mounted() {
    try {
      let config = this.$config.opciones.find((c) => c.id == 11);
      this.config_11 = !!config.valor;
    } catch (e) {
      this.$toast.error("Error en configuracion 11. " + e, new Toast());
    }
  },
};
</script>

<style scoped>
.sale-setup {
  --primary: #0353a4;
  --primary-hover: #034582;
  --primary-light: #347ea8;
  --primary-tint: #eef5f9;
  --success: #00a63e;
  --warning: #ffc23c;
  --warning-tint: #fff6df;
  --warning-text: #8a5a00;
  --surface: #fff;
  --surface-alt: #fafbfc;
  --border: #e2e4e8;
  --border-strong: #c7cbd1;
  --text: #1a1d23;
  --text-soft: #33363c;
  --muted: #6b7280;
  --r-sm: 8px;
  --r-md: 14px;

  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: 0 3px 12px rgba(17, 29, 45, 0.045);
  padding: 15px 17px;
  color: var(--text);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ==== Selector de servicio ==== */
.service-switch {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: var(--surface-alt);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  overflow-x: auto;
  scrollbar-width: thin;
}
.service-switch .service-btn {
  background: transparent;
  border: 0;
  border-radius: 6px;
  padding: 5px 9px;
  font-size: 10px;
  font-weight: 700;
  min-height: 28px;
  white-space: nowrap;
  color: var(--muted);
  cursor: pointer;
  transition: 0.15s ease;
  flex: 1 1 auto;
}
.service-switch .service-btn:hover:not(.active) {
  background: var(--surface);
  color: var(--text-soft);
}
.service-switch .service-btn.active {
  color: #fff;
  box-shadow: none;
}
/* Colores por tipo de servicio (los mismos del rediseño) */
.service-switch .service-btn.active.service-mesa {
  background: #2196f3;
}
.service-switch .service-btn.active.service-llevar {
  background: #f58b00;
}
.service-switch .service-btn.active.service-domicilio {
  background: #49ae4f;
}
.service-switch .service-btn.active.service-reservacion {
  background: var(--primary);
}

/* ==== Formularios ==== */
.service-forms {
  position: relative;
  min-height: 0;
}
.service-forms > * {
  display: block;
}

/* ==== Transición ==== */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

/* ==== Responsive ==== */
@media (max-width: 700px) {
  .sale-setup {
    padding: 12px;
  }
  .service-switch .service-btn {
    padding: 9px 11px;
    font-size: 11px;
    min-height: 40px;
    flex: none;
  }
}

@media (min-width: 1500px) {
  .sale-setup {
    padding: 16px 18px;
  }
  .service-switch .service-btn {
    font-size: 15px;
    min-height: 48px;
    padding: 12px 18px;
  }
}
</style>